import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import Header from './Header';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';
import { theme } from '../../styles/theme';

const Main = styled.main`
  min-height: calc(100vh - 300px);
  padding-top: 70px; // Account for fixed header
`;

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  
  return (
    <>
      <Header />
      <Main>{children}</Main>
      <Footer />
      <ScrollToTop />
    </>
  );
};

export default Layout; 